import React, { FC } from 'react';
import * as S from '@/components/PresetPhotoPicker/PresetPhotoPicker.styles';
import { CheckboxSelectedIcon } from '@/components/UI/Icons/Icons';
import { AdImage } from '@/components/AdImages/AdImages.types';
import { CommonTestIds } from '@/__e2e__/testIds/common';

interface Props {
  images: AdImage[];
  currentSelection: AdImage[];
  toggle: (image: AdImage) => void;
  maxHeight?: number;
  hasPadding?: boolean;
}

export const PresetPhotoPickerGrid: FC<Props> = ({
  images,
  currentSelection,
  toggle,
  maxHeight,
  hasPadding,
}) => {
  return (
    <S.PresetPhotoPickerGrid
      $maxHeight={maxHeight}
      $hasPadding={hasPadding}
      data-testid={CommonTestIds.adImages.presetPhotoPickerGrid}
    >
      {images.map(image => {
        const isSelected = !!currentSelection.find(({ id }) => id === image.id);
        return (
          <S.PresetPhotoPickerItem
            key={image.id}
            onClick={() => toggle(image)}
            data-testid={CommonTestIds.adImages.presetPhotoItem}
          >
            <S.PresetPhotoPickerImage
              alt=""
              src={image.src}
              $isSelected={isSelected}
            />

            <S.PresetPhotoPickerCheckbox $isSelected={isSelected}>
              {isSelected && (
                <CheckboxSelectedIcon data-testid="checkbox-selected-icon" />
              )}
            </S.PresetPhotoPickerCheckbox>
          </S.PresetPhotoPickerItem>
        );
      })}
    </S.PresetPhotoPickerGrid>
  );
};

PresetPhotoPickerGrid.displayName = 'PresetPhotoPickerGrid';
